import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { OnboardingService } from "../../shared/service/onboarding.service";
import { OnboardEducationDetails } from "../../shared/models/OnboardEducationDetails";
import {
  FormControl,
  FormGroup,
  FormArray,
  FormBuilder,
  AbstractControl,
  Validators,
  ValidationErrors,
} from "@angular/forms";
import { OnboardPreviousEmploymentDetails } from "../../shared/models/OnboardPreviousEmploymentDetails";
import { OnboardProfessionalReferenceDetails } from "../../shared/models/OnboardProfessionalReferenceDetails";
import { OnboardEmergencyContactDetails } from "../../shared/models/OnboardEmergencyContactDetails";
import {
  MatDialog,
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS,
} from "@angular/material";
import {
  ConfirmDialogComponent,
  ConfirmDialogModel,
} from "../../shared/components/confirm-dialog/confirm-dialog.component";
import { ToastrService } from "ngx-toastr";
import { OnboardVrifications } from "../../shared/models/OnboardVrifications";
import { UserService } from "../../shared/service/user.service";
import { OnboardEmployeeDetails } from "../../shared/models/OnboardEmployeeDetails";
import { OnboardEmployeePersonalDetails } from "../../shared/models/OnboardEmployeePersonalDetails";
import { OnboardEmployeePassportVisaInfo } from "../../shared/models/OnboardEmployeePassportVisaInfo";
import { OnboardEmployeeFinanceDetails } from "../../shared/models/OnboardEmployeeFinanceDetails";
import { AppConfig } from "../../app.config";
import * as _moment from "moment";
import { DatePipe, formatDate } from "@angular/common";
import { OnboardingExportToEmp } from "../../shared/models/onboardingExportToEmp";
import { EmployeeService } from "../../shared/service/employee.service";
import { PreviousEmploymentComponent } from "../previous-employment/previous-employment.component";
import { BasicEmpDetailsComponent } from "../basic-emp-details/basic-emp-details.component";
import { PersonalDetailsComponent } from "../personal-details/personal-details.component";
import { EducationDetailsComponent } from "../education-details/education-details.component";
import { ReferenceDetailsComponent } from "../reference-details/reference-details.component";
import { PassportvisaInformationComponent } from "../passportvisa-information/passportvisa-information.component";
import { FinanceDetailsComponent } from "../finance-details/finance-details.component";
import { ComponentIdentificationService } from "../../shared/service/component-identification.service";
import { isNullOrUndefined } from "util";
import { OnboardEmpEducationInformation } from "../../shared/models/OnboardEmpEducationInformation";
import { EmployeeModel } from "../../shared/models/employee.model";
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from "@angular/material-moment-adapter";
import { FileUploadService } from "../../shared/service/fileUpload.service";
import { OnboardEmpPreviousEmploymentDtls } from "../../shared/models/OnboardPrevEmploymentInfo";
import { BasicEmployeeDetails } from "../../shared/models/basicemployeedetails.model";
import { BehaviorSubject } from "rxjs";
import { OnboardingHRDetail } from "../../shared/models/OnboardingHRDetail";

const moment = _moment;
export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MMM-YYYY",
  },
  display: {
    dateInput: "DD-MMM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

@Component({
  selector: "app-employee-verification",
  templateUrl: "./employee-verification.component.html",
  styleUrls: ["./employee-verification.component.css"],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class EmployeeVerificationComponent implements OnInit {
  @ViewChild(BasicEmpDetailsComponent, { static: false })
  basicEmpDetComponent: BasicEmpDetailsComponent;
  @ViewChild(PersonalDetailsComponent, { static: false })
  personalDetailsComponent: PersonalDetailsComponent;
  @ViewChild(EducationDetailsComponent, { static: false })
  educationDetailsComponent: EducationDetailsComponent;
  @ViewChild(PreviousEmploymentComponent, { static: false })
  previousEmploymentComponent: PreviousEmploymentComponent;
  //@ViewChild(ReferenceDetailsComponent, { static: false }) referenceDetailsComponent: ReferenceDetailsComponent;
  @ViewChild(PassportvisaInformationComponent, { static: false })
  passportvisaInformationComponent: PassportvisaInformationComponent;
  @ViewChild(FinanceDetailsComponent, { static: false })
  financeDetailsComponent: FinanceDetailsComponent;
  MAX_SIZE: number = 1048576;
  slug: any;
  error: string;
  selectedIndex: number;
  MaritalStatus: any;
  newAttribute: any = {};
  HREmp: OnboardingHRDetail;
  selected = new FormControl(0);
  rows: FormArray = this.fb.array([]);
  prevEmp: FormArray = this.fb.array([]);
  visaArray: FormArray = this.fb.array([]);
  passportArray: FormArray = this.fb.array([]);
  prevEmploymentDetails: OnboardEmpPreviousEmploymentDtls;
  referenceDetails: OnboardProfessionalReferenceDetails[] = [];
  emerContactDetails: OnboardEmergencyContactDetails[] = [];
  result: any;
  checkBox = false;
  PersonalDetCB = false;
  EducationDetCB = false;
  ReferenceDetCB = false;
  PrevEmpDetCB = false;
  PassportDetCB = false;
  FinanceDetCB = false;
  empCode: number;
  employeelist: EmployeeModel[];
  activeFteEmailList: EmployeeModel[];
  employeeDetails: OnboardEmployeeDetails;
  personalDetails: OnboardEmployeePersonalDetails;
  educationDetails: OnboardEducationDetails[] = [];
  passportVisaDetails: OnboardEmployeePassportVisaInfo;
  FinanceDetails: OnboardEmployeeFinanceDetails;
  VerificationDetails: OnboardVrifications[] = [];
  Verify: OnboardVrifications;
  EmpId: number;
  datePipe: DatePipe;
  Status: number;
  Check: number = 1;
  empList: any[];
  exportEmp: OnboardingExportToEmp;
  duplicatemp: any;
  emailemp: any;
  verificationForm: FormGroup;
  submitted: boolean;
  exception: false;
  checkBoxDisable = false;
  PersonalDetCBDisable = false;
  EducationDetCBDisable = false;
  ReferenceDetCBDisable = false;
  PrevEmpDetCBDisable = false;
  PassportDetCBDisable = false;
  FinanceDetCBDisable = false;
  Children: FormArray = this.fb.array([]);
  additionalQualifications: any[];
  educationInfo: OnboardEmpEducationInformation;
  todayDate: Date;
  peopleManagerCode: any;
  seniorManagerCode: any;
  tempPMList: pmObj[] = [];
  filteredPMList: any;
  filteredSMList: any;
  tempSMList: pmObj[] = [];
  isLoader: boolean = true;
  PriorExperienceYears: number;
  PriorExperienceMonths: number;
  isLateral: boolean = false;
  loader: boolean = false;
  private employeelistSubject = new BehaviorSubject<EmployeeModel[]>([]);
  constructor(
    private empsvc: EmployeeService,
    private router: Router,
    private route: ActivatedRoute,
    private config: AppConfig,
    private _service: OnboardingService,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private userService: UserService,
    private emp_Svc: EmployeeService,
    private file_Svc: FileUploadService,
    private chngCom_Svc: ComponentIdentificationService
  ) {
    this.todayDate = new Date();
  }
  ngOnInit() {
    //Assign the parent component name to recognize the parent in child component
    this.chngCom_Svc.changeComponentName("app-employee-verification");
    //get the slug from url
    this.route.params.subscribe((params) => {
      this.slug = params["slug"];
      //status 2 indicates that employee has submited the details and hr need to verify
      this.Status = 2;
    });
    this.verificationForm = this.fb.group({
      empCode: ["", [Validators.required]],
      emailId: ["", [Validators.required, this.emailDomain]],
      peopleManager: ["", [Validators.required, this.requireMatchPM.bind(this),]],
      seniorManager: ["", [Validators.required, this.requireMatchSM.bind(this),]],
    });
    //get the login employee code
    this.empCode = this.userService.getEmpCode();
    this.educationInfo = new OnboardEmpEducationInformation();
    this.employeeDetails = new OnboardEmployeeDetails();
    this.personalDetails = new OnboardEmployeePersonalDetails();
    this.passportVisaDetails = new OnboardEmployeePassportVisaInfo();
    this.FinanceDetails = new OnboardEmployeeFinanceDetails();
    this.Verify = new OnboardVrifications();
    this.exportEmp = new OnboardingExportToEmp();
    this.HREmp = new OnboardingHRDetail();
    this.selectedIndex = 0;
    this.getAllEmployees();
    this.getAllActiveFTE();
    setTimeout(() => {
      this.isLoader = false;
    }, 1500);
  }
  get f() {
    return this.verificationForm.controls;
  }

  //It is called for every tab change
  tabClick() {
    this.isLoader = true;
    this.GetVerificationStatus();
    this._service.getEmployeebyId(this.EmpId).subscribe((data: any) => {
      this.isLateral = data && data.HiringType === "Lateral" ? true : false;
    });
    setTimeout(() => {
      this.isLoader = false;
    }, 1500);
  }

  getEmployeeList() {
    this.emp_Svc.getAllEmployees().subscribe(
      (data: any[]) => {
        this.empList = data;
        this.tempSMList = [];
        this.tempPMList = [];
        this.empList.forEach((el) => {
          let item = new pmObj();
          item.pmDisplayName = el.FirstName + " - " + el.DesignationName;
          item.smDisplayName = el.FirstName + " - " + el.DesignationName;
          item.pmEmpCode = el.EmpCode;

          this.tempPMList.push(item);
          this.tempSMList.push(item);
        });

        this.filteredPMList = this.tempPMList;
        this.filteredSMList = this.tempSMList;

        this.GetVerificationStatus();
      },
      (error) => (this.error = error)
    );
  }

  //To make the mat-tab move to next tab
  changeTab() {
    this.selected.setValue(this.selected.value + 1);
    this.GetVerificationStatus();
  }

  //To make the mat-tab move to previous tab
  BackTab() {
    this.selected.setValue(this.selected.value - 1);
    this.GetVerificationStatus();
  }

  //To clear the form data in each tab by switch condition
  ResetData(value) {
    switch (value) {
      case "basicdetails":
        this.basicEmpDetComponent.EmpDetform.reset();
        this.basicEmpDetComponent.EmpAddform.reset();
        this.basicEmpDetComponent.getEmployeebySlugStatus();
        break;
      case "personaldetails":
        this.personalDetailsComponent.PersonalDetform.reset();
        this.Children.clear();
        this.personalDetailsComponent.GetEmployeePersonalDetails();
        break;
      case "educationdetails":
        this.educationDetailsComponent.rows = this.fb.array([]);
        this.educationDetailsComponent.reset();
        this.educationDetailsComponent.getData();
        break;
      case "prevemploymentdetails":
        this.previousEmploymentComponent.prevEmp = this.fb.array([]);
        this.previousEmploymentComponent.PrevEmploymentDetForm.reset();
        this.previousEmploymentComponent.reset();
        this.previousEmploymentComponent.GetOnboardPrevEmploymentDetails();
        break;
      case "referencedetails":
        this.previousEmploymentComponent.GetOnboardEmpReferences();
        break;
      case "passportvisadetails":
        this.passportvisaInformationComponent.passportArray.reset();
        this.passportvisaInformationComponent.visaArray = this.fb.array([]);
        this.passportvisaInformationComponent.GetPassportVisaInfo();
        break;
      case "financedetails":
        this.financeDetailsComponent.FinanceForm.reset();
        this.financeDetailsComponent.GetOnboardEmpolyeeFinanceDetails();
        break;
    }
  }

  //Read the output values from child components
  getEmpId(val) {
    this.EmpId = val;
    this.getEmployeeList();
  }
  getEmployeeDtlsOutput(val) {
    this.employeeDetails = val;
  }
  getEducationDtlsOutput(val) {
    this.rows = val;
  }
  getPersonalDtlsOutput(val) {
    this.personalDetails = val;
  }
  getPrevEmploymentDtlsOutput(val) {
    this.prevEmp = val;
  }
  getReferenceDtlsOutput(val) {
    this.referenceDetails = val;
  }
  getPassportVisaDtlsOutput(val) {
    this.passportArray = val;
  }
  getVisaDtlsOutput(val) {
    this.visaArray = val;
  }
  getFinanceDtlsOutput(val) {
    this.FinanceDetails = val;
  }
  getChildrenArrayOutput(val) {
    this.Children = val;
  }
  getAdditionalQualificationsOutput(val) {
    this.additionalQualifications = val;
  }

  SaveEducationDetails(value) {
    this.datePipe = new DatePipe("en-US");
    if (!this.educationDetailsComponent.EducationDetailForm.invalid) {
      this.educationDetailsComponent.assignDocumentsListToObject();
      for (var i = 0; i < this.rows.value.length; i++) {
        this.rows.value[i].EmpId = this.EmpId;
        this.rows.value[i].ModifiedBy = this.empCode.toString();

        if (
          isNullOrUndefined(this.rows.value[i].OnboardHREmpDocs) ||
          this.rows.value[i].OnboardHREmpDocs.length < 1
        ) {
          this.toastr.warning(
            "One attachment is mandatory for your qualification " +
              this.rows.value[i].Qualification
          );
          return;
        }
        if (this.rows.value[i].OnboardHREmpDocs.length > 0) {
          if (
            isNullOrUndefined(this.rows.value[i].Qualification) ||
            this.rows.value[i].Qualification == "" ||
            isNullOrUndefined(this.rows.value[i].MarksPercent) ||
            this.rows.value[i].MarksPercent == "" ||
            isNullOrUndefined(this.rows.value[i].YearOfPassing) ||
            (this.rows.value[i].YearOfPassing != null &&
              this.rows.value[i].YearOfPassing.toString() == "") ||
            isNullOrUndefined(this.rows.value[i].University) ||
            this.rows.value[i].University == ""
          ) {
            this.toastr.warning("Please fill the required fields");
            return;
          }
          if (
            (this.rows &&
              this.rows.value[i] &&
              this.rows.value[i].YearOfPassing === "0000") ||
            (this.rows &&
              this.rows.value[i] &&
              this.rows.value[i].YearOfPassing != null &&
              this.rows.value[i].YearOfPassing != "" &&
              this.rows.value[i].YearOfPassing.toString().startsWith("0"))
          ) {
            this.toastr.warning("Invalid year of passing");
            return;
          }
        }
        if (this.EducationDetCB == true) {
          this.SaveVerificationDetails(this.selected.value + 1);
          this.rows.value[i].onboardVrifications = this.Verify;
        } else {
          this.rows.value[i].onboardVrifications = null;
        }
      }
      this.educationInfo.educationDetails = this.rows.value;
    } else {
      this.toastr.warning("Please fill in the required fields");
      return;
    }

    //Check whether employee contains additional qualifications
    if (
      this.additionalQualifications != null &&
      this.additionalQualifications.length != 0
    ) {
      var count = 0;
      this.educationInfo.AdditionalQualifications = [];
      for (var i = 0; i < this.additionalQualifications.length; i++) {
        if (
          !isNullOrUndefined(this.additionalQualifications[i].Name) &&
          this.additionalQualifications[i].Name != ""
        ) {
          if (
            !this.isEmptyOrSpaces(this.additionalQualifications[i].Name) &&
            isNullOrUndefined(this.additionalQualifications[i].additionalDocs)
          ) {
            this.toastr.warning(
              "One attachment is mandatory for your additional qualification " +
                this.additionalQualifications[i].Name
            );
            return;
          }
        }
        // if name field is empty and doc is attached ,name should also be entered
        else if (
          isNullOrUndefined(this.additionalQualifications[i].Name) ||
          this.additionalQualifications[i].Name == ""
        ) {
          if (
            !isNullOrUndefined(this.additionalQualifications[i].additionalDocs)
          ) {
            this.toastr.warning(
              "Please provide the Name of the Qualification/Certification"
            );
            return;
          }
        }
        //assign additional qualifications data to the education info object
        if (
          !isNullOrUndefined(this.additionalQualifications[i].additionalDocs)
        ) {
          for (
            var j = 0;
            j < this.additionalQualifications[i].additionalDocs.length;
            j++
          ) {
            this.educationInfo.AdditionalQualifications =
              this.educationInfo.AdditionalQualifications.concat(
                this.additionalQualifications[i].additionalDocs[j]
              );
            this.educationInfo.AdditionalQualifications[count].EmpId =
              this.EmpId;
            this.educationInfo.AdditionalQualifications[count].ModifiedBy =
              this.empCode.toString();
            this.educationInfo.AdditionalQualifications[count].DocTypeName =
              this.additionalQualifications[i].Name;
            count++;
          }
        }
      }
    }
    this.loader = true;

    this._service.saveEducationDetails(this.educationInfo).subscribe(
      (data: any) => {
        this.educationDetailsComponent.getData();
        this.GetVerificationStatus();
        this.toastr.success("Saved Successfully");
        //if value is true then it is moved to next tab
        setTimeout(() => {
          this.loader = false;
        }, 800);

        if (value) {
          this.changeTab();
        }
      },
      (error) => (this.error = error)
    );
  }

  //returns true if given string is empty or had spaces
  isEmptyOrSpaces(str) {
    return str === null || str.match(/^ *$/) !== null;
  }

  SavePrevEmploymentDetails(value) {
    this.previousEmploymentComponent.PrevEmploymentDetForm.markAllAsTouched();
    if (
      (isNullOrUndefined(
        this.previousEmploymentComponent.PriorExperienceYears
      ) ||
        this.isEmptyOrSpaces(
          this.previousEmploymentComponent.PriorExperienceYears.toString()
        )) &&
      this.isLateral
    ) {
      // this.IsValidateTrue.emit(true);
      this.previousEmploymentComponent.getIsValidTrueOutput(true);
      this.toastr.warning("Please fill in the required fields.");
      return;
    }

    if (this.prevEmp && this.prevEmp.length === 0 && this.isLateral) {
      this.toastr.warning("Please fill the Previous employement details.");
      return;
    }

    this.previousEmploymentComponent.getIsValidTrueOutput(false);

    for (let i = 0; i < this.referenceDetails.length; i++) {
      const contactPhoneNumber = this.referenceDetails[i].ContactPhoneNumber;
      if (!isNullOrUndefined(contactPhoneNumber)) {
        if (contactPhoneNumber.length !== 10) {
          this.toastr.warning("Please enter a valid 10-digit Phone Number");
          return;
        }
      }
    }
    this.datePipe = new DatePipe("en-US");
    this.previousEmploymentComponent.assignDocumentsListToObject();
    const prevEmpDetails =
      this.previousEmploymentComponent.GetPriorExperience();
    if (prevEmpDetails != null) {
      this.PriorExperienceYears = prevEmpDetails.PriorExperienceYears;
      this.PriorExperienceMonths = prevEmpDetails.PriorExperienceMonths;
    }
    for (var i = 0; i < this.prevEmp.value.length; i++) {
      this.prevEmp.value[i].EmpId = this.EmpId;
      const date =
        this.previousEmploymentComponent.getBasicEmployeeByCodeforDate();
      //if (!isNullOrUndefined(this.empCode)) {
      this.prevEmp.value[i].ModifiedBy = this.EmpId.toString();
      this.prevEmp.value[i].CreatedBy = this.EmpId.toString();
      // }
      //this.prevEmp.value[i].ModifiedBy = this.empCode.toString();
      if (!isNullOrUndefined(this.prevEmp.value[i].FromDate)) {
        this.prevEmp.value[i].FromDate = new Date(
          this.datePipe.transform(
            this.prevEmp.value[i].FromDate,
            this.config.dateFormat()
          )
        );
      }
      if (!isNullOrUndefined(this.prevEmp.value[i].ToDate)) {
        this.prevEmp.value[i].ToDate = new Date(
          this.datePipe.transform(
            this.prevEmp.value[i].ToDate,
            this.config.dateFormat()
          )
        );
      }
      if (
        this.prevEmp.value[i].FromDate != null &&
        this.prevEmp.value[i].ToDate != null &&
        this.prevEmp.value[i].FromDate > this.prevEmp.value[i].ToDate
      ) {
        this.toastr.warning("From Date should not be greater than To Date");
        return;
      }
      if (
        this.prevEmp.value[i].FromDate != null &&
        this.prevEmp.value[i].FromDate > date
      ) {
        this.toastr.warning(
          "From Date should be less than " +
            formatDate(date, "dd-MMM-yyyy", "en_US")
        );
        return;
      }
      if (
        this.prevEmp.value[i].ToDate != null &&
        formatDate(this.prevEmp.value[i].ToDate, "yyyy-MM-dd", "en_US") >
          formatDate(date, "yyyy-MM-dd", "en_US")
      ) {
        this.toastr.warning(
          "To Date should be less than " +
            formatDate(date, "dd-MMM-yyyy", "en_US")
        );
        return;
      }
      if (this.PrevEmpDetCB == true) {
        this.SaveVerificationDetails(this.selected.value + 1);
        this.prevEmp.value[i].onboardVrifications = this.Verify;
        //this.referenceDetails[i].onboardVrifications = this.Verify;
      } else {
        this.prevEmp.value[i].onboardVrifications = null;
        //this.referenceDetails[i].onboardVrifications = null;
      }
      //condition to check whether the below fields has value
      if (
        !this.isEmptyOrSpaces(this.prevEmp.value[i].CompanyName) ||
        this.prevEmp.value[i].CompanyName != ""
      ) {
        if (
          ((this.isEmptyOrSpaces(this.prevEmp.value[i].Designation) ||
            this.prevEmp.value[i].Designation == "") &&
            (this.isEmptyOrSpaces(this.prevEmp.value[i].JobLocation) ||
              this.prevEmp.value[i].JobLocation == "")) ||
          (isNullOrUndefined(this.prevEmp.value[i].ToDate) &&
            isNullOrUndefined(this.prevEmp.value[i].FromDate))
        ) {
          this.toastr.warning(
            "Please fill the remaining fields for" +
              this.prevEmp.value[i].CompanyName
          );
          return;
        }
        //if any field has value then attachment of document is madatory
        if (
          isNullOrUndefined(this.prevEmp.value[i].OnboardHREmpDocs) ||
          this.prevEmp.value[i].OnboardHREmpDocs.length < 1
        ) {
          this.toastr.warning(
            "One attachment is mandatory for your experience in " +
              this.prevEmp.value[i].CompanyName
          );
          return;
        }
        if (
          this.prevEmp.value[i].OnboardHREmpDocs != null &&
          this.prevEmp.value[i].OnboardHREmpDocs.length > 0
        ) {
          for (
            var k = 0;
            k < this.prevEmp.value[i].OnboardHREmpDocs.length;
            k++
          ) {
            this.prevEmp.value[i].OnboardHREmpDocs[k].EmpId = this.EmpId;
          }
          if (
            this.prevEmp.value[i].Designation == "" ||
            this.prevEmp.value[i].JobLocation == "" ||
            isNullOrUndefined(this.prevEmp.value[i].ToDate) ||
            isNullOrUndefined(this.prevEmp.value[i].FromDate) ||
            this.prevEmp.value[i].CompanyName == ""
          ) {
            this.toastr.warning("Please fill the required fields");
            return;
          }
        }
      } else {
        if (
          (!this.isEmptyOrSpaces(this.prevEmp.value[i].Designation) &&
            this.prevEmp.value[i].Designation != "" &&
            !this.isEmptyOrSpaces(this.prevEmp.value[i].JobLocation) &&
            this.prevEmp.value[i].JobLocation != "") ||
          (!isNullOrUndefined(this.prevEmp.value[i].ToDate) &&
            !isNullOrUndefined(this.prevEmp.value[i].FromDate))
        ) {
          if (
            this.isEmptyOrSpaces(this.prevEmp.value[i].CompanyName) ||
            this.prevEmp.value[i].CompanyName == ""
          ) {
            this.toastr.warning(
              "Please enter company name in previous employment."
            );
            return;
          }
        }
      }
      if (
        this.isLateral &&
        (this.prevEmp.value[i].Designation == "" ||
          this.prevEmp.value[i].JobLocation == "" ||
          isNullOrUndefined(this.prevEmp.value[i].ToDate) ||
          isNullOrUndefined(this.prevEmp.value[i].FromDate) ||
          this.prevEmp.value[i].CompanyName == "")
      ) {
        this.toastr.warning("Please fill the Previous employement details.");
        this.loader = false;
        return;
      }
      if (
        this.prevEmp.value[i].OnboardHREmpDocs != null &&
        this.prevEmp.value[i].OnboardHREmpDocs != "" &&
        this.prevEmp.value[i].OnboardHREmpDocs.length > 0
      ) {
        if (
          this.prevEmp.value[i].Designation == "" ||
          this.prevEmp.value[i].JobLocation == "" ||
          isNullOrUndefined(this.prevEmp.value[i].ToDate) ||
          isNullOrUndefined(this.prevEmp.value[i].FromDate) ||
          this.prevEmp.value[i].CompanyName == ""
        ) {
          this.toastr.warning("Please fill the required fields");
          return;
        }
      }
    }
    if (
      this.prevEmp.value.length > 0 &&
      !isNullOrUndefined(this.prevEmp.value[0].CompanyName) &&
      this.prevEmp.value[0].CompanyName !== ""
    ) {
      for (var i = 0; i < this.referenceDetails.length; i++) {
        this.referenceDetails[i].EmpId = this.EmpId;
        this.referenceDetails[i].ModifiedBy = this.EmpId.toString();
        this.referenceDetails[i].CreatedBy = this.EmpId.toString();
        if (
          !isNullOrUndefined(this.referenceDetails[0].Company) ||
          !isNullOrUndefined(this.prevEmp.value[i].CompanyName)
        ) {
          if (!isNullOrUndefined(this.referenceDetails[0].Company)) {
            if (this.referenceDetails[0].Company != "") {
              if (
                isNullOrUndefined(this.referenceDetails[0].ContactPersonName) ||
                isNullOrUndefined(this.referenceDetails[0].ContactPhoneNumber) ||
                isNullOrUndefined(this.referenceDetails[0].ContactInfo) ||
                this.referenceDetails[0].ContactInfo == "" ||
                this.referenceDetails[0].ContactPersonName == "" ||
                this.referenceDetails[0].ContactPhoneNumber == ""
              ) {
                this.toastr.warning(
                  "Please fill the remaining fields for " +
                  this.referenceDetails[0].Company
                );
                return;
              }
            } else {
              this.toastr.warning(
                "Please enter Company name for " +
                this.prevEmp.value[i].CompanyName
              );
              return;
            }
          } else {
            this.toastr.warning(
              "One reference detail is required for your experience in " +
              this.prevEmp.value[0].CompanyName
            );
            return;
          }
        }
      }

      for (var i = 1; i < this.referenceDetails.length; i++) {
        if (
          isNullOrUndefined(this.referenceDetails[i].ContactPersonName) ||
          isNullOrUndefined(this.referenceDetails[i].ContactPhoneNumber) ||
          isNullOrUndefined(this.referenceDetails[i].ContactInfo) ||
          this.referenceDetails[i].ContactPersonName === "" ||
          this.referenceDetails[i].ContactPhoneNumber === "" ||
          this.referenceDetails[i].ContactInfo === ""
        ) {
          this.toastr.warning("Please fill the remaining fields");
          return;
        }
      }
    }

    this.prevEmploymentDetails = new OnboardEmpPreviousEmploymentDtls();
    this.prevEmploymentDetails.onboardEmpPreviousEmploymentDtls =
      this.prevEmp.value;
    this.prevEmploymentDetails.PriorExperienceYears = this.PriorExperienceYears;
    this.prevEmploymentDetails.PriorExperienceMonths =
      this.PriorExperienceMonths;
    this.loader = true;
    this._service
      .SavePrevEmploymentDetails(this.prevEmploymentDetails)
      .subscribe(
        (data: any) => {
          this.previousEmploymentComponent.GetOnboardPrevEmploymentDetails();
          this.GetVerificationStatus();
          setTimeout(() => {
            this.loader = false;
          }, 800);
          //this.toastr.success("Saved Successfully");
          //if value is true then it is moved to next tab
          // if (value) { this.changeTab(); }
        },
        (error) => (this.error = error)
      );
    this._service.SaveReferenceDetails(this.referenceDetails).subscribe(
      (data: any) => {
        this.GetVerificationStatus();
        this.toastr.success("Saved Successfully");
        this.previousEmploymentComponent.GetOnboardEmpReferences();
        //if value is true then it is moved to next tab
        if (value) {
          this.changeTab();
        }
      },
      (error) => (this.error = error)
    );
  }

  /*SavereferenceDetails(value) {
    for (var i = 0; i < this.referenceDetails.length; i++) {
      this.referenceDetails[i].EmpId = this.EmpId;
      this.referenceDetails[i].ModifiedBy = this.empCode.toString();
      if (this.ReferenceDetCB == true) {
        this.SaveVerificationDetails(this.selected.value + 1);
        this.referenceDetails[i].onboardVrifications = this.Verify;
      }
      else {
        this.referenceDetails[i].onboardVrifications = null;
      }
    }
    this._service.SaveReferenceDetails(this.referenceDetails).subscribe((data: any) => {
      this.toastr.success("Saved Successfully");
      //if value is true then it is moved to next tab
      if (value) { this.changeTab(); }
    },
      error => this.error = error);

  }*/
  async getAllEmployees() {
    this.employeelist = [];
    try {
      const data: EmployeeModel[] = await this.emp_Svc
        .getAllEmployees()
        .toPromise();
      this.employeelist = data || [];
    } catch (error) {
      this.error = error;
      throw error;
    }
  }

  getAllActiveFTE() {
    this.activeFteEmailList = [];
    this.empsvc.getAllActiveFTEEmployees().subscribe(
      (data: EmployeeModel[]) => {
        this.activeFteEmailList = data;
      },
      (error) => (this.error = error)
    );
  }
  onPeopleManagerChange(event) {
    this.exportEmp.peopleManagerCode = event.option.id;
  }
  onSeniorManagerChange(event) {
    this.exportEmp.seniorManagerCode = event.option.id;
  }

  getDetailsByID() {
    this._service.getEmployeebyId(this.EmpId).subscribe((data: any) => {
      this.HREmp = data;
    });
  }

  async SubmitVerification() {
    this.getDetailsByID();
    await this.getAllEmployees();

    if (
      this.exportEmp.empCode != null &&
      this.exportEmp.peopleManagerCode != null &&
      this.exportEmp.seniorManagerCode != null
    ) {
      this.duplicatemp = this.employeelist.filter(
        (emp) => this.exportEmp.empCode == emp.EmpCode
      );
      this.emailemp = this.activeFteEmailList.filter(
        (email) =>
          this.exportEmp.email.trim().toLowerCase() == email.Email.toLowerCase()
      );
      if (this.duplicatemp.length != 0 || this.emailemp.length != 0) {
        this.submitted = false;
        if (this.duplicatemp.length && this.emailemp.length >= 1) {
          this.toastr.warning("Same Employee code and Email exists");
          this.exportEmp.email = null;
          this.exportEmp.empCode = null;
        } else if (this.emailemp.length >= 1) {
          this.toastr.warning("Same Email exists");
          this.exportEmp.email = null;
        } else if (this.duplicatemp.length >= 1) {
          this.toastr.warning("Same Employee code exists");
          this.exportEmp.empCode = null;
        }
      } else {
        var shouldReturn = false;
        if (this.employeeDetails.Type == "New") {
          var employee =
            this.employeelist != null
              ? this.employeelist
                  .filter(
                    (emp) =>
                      (emp.PAN != null &&
                        this.employeeDetails.PAN != null &&
                        emp.PAN == this.employeeDetails.PAN) ||
                      (emp.Aadhar != null &&
                        this.employeeDetails.Aadhar != null &&
                        emp.Aadhar == this.employeeDetails.Aadhar) ||
                      (emp.SecondaryEmail == this.employeeDetails.Email &&
                        formatToCustomDate(emp.DOB) ===
                          formatToCustomDate(this.employeeDetails.DOB) &&
                        this.employeeDetails.GroupId != emp.GroupId)
                  )
                  .pop()
              : null;
          if (employee != null && employee != undefined) {
            var date = employee.IsMigratedOnH1
              ? employee.US_DOE
              : employee.DateOfExit;
            if (
              (employee.IsMigratedOnH1
                ? employee.US_DOE == null
                : employee.DateOfExit == null) &&
              employee.EmpCode != this.exportEmp.empCode
            ) {
              this.toastr.warning(
                "PAN/Aadhar/Email & DOB is matching with the group Id " +
                  employee.GroupId +
                  ". Date of exit is null for earlier record/s"
              );
              this.loader = false;
              return;
            } else if (
              employee.IsMigratedOnH1 == true
                ? employee.US_DOE != null
                : employee.DateOfExit != null &&
                  this.employeeDetails.GroupId != employee.GroupId
            ) {
              if (
                confirm(
                  "PAN/Aadhar/Email & DOB is matching with the group Id " +
                    employee.GroupId +
                    ". Click OK to use this " +
                    employee.GroupId +
                    " or cancel to review and modify the details."
                )
              ) {
                this.employeeDetails.GroupId = employee.GroupId;
                this.employeeDetails.Type = "Re-hire";
                if (
                  date != null &&
                  formatToCustomDate(date) >=
                    formatToCustomDate(this.HREmp.DOJ) &&
                  employee.EmpCode != this.exportEmp.empCode
                ) {
                  this.toastr.warning(
                    "PAN/Aadhar/Email & DOB is matching with the group Id " +
                      employee.GroupId +
                      ". DOJ should be after the earlier Date of exit " +
                      formatDate(date, "dd-MMM-yyyy", "en_US")
                  );
                  shouldReturn = true;
                  this.loader = false;
                  return;
                }
                if (shouldReturn) {
                  this.loader = false;
                  return;
                }
              } else {
                this.loader = false;
                return;
              }
            }
            if (
              date != null &&
              formatToCustomDate(date) >= formatToCustomDate(this.HREmp.DOJ) &&
              employee.EmpCode != this.exportEmp.empCode
            ) {
              this.toastr.warning(
                "PAN/Aadhar/Email & DOB is matching with the group Id " +
                  employee.GroupId +
                  ". DOJ should be after the earlier Date of exit " +
                  formatDate(date, "dd-MMM-yyyy", "en_US")
              );
              shouldReturn = true;
              this.loader = false;
              return;
            }
          }
        } else {
          var employee =
            this.employeelist != null
              ? this.employeelist
                  .filter(
                    (emp) =>
                      (emp.PAN != null &&
                        this.employeeDetails.PAN != null &&
                        emp.PAN == this.employeeDetails.PAN) ||
                      (emp.Aadhar != null &&
                        this.employeeDetails.Aadhar != null &&
                        emp.Aadhar == this.employeeDetails.Aadhar) ||
                      (emp.SecondaryEmail == this.employeeDetails.Email &&
                        formatToCustomDate(emp.DOB) ===
                          formatToCustomDate(this.employeeDetails.DOB) &&
                        this.employeeDetails.GroupId == emp.GroupId)
                  )
                  .pop()
              : null;
          if (employee != undefined && employee != null) {
            var date = employee.IsMigratedOnH1
              ? employee.US_DOE
              : employee.DateOfExit;
            if (
              date != null &&
              formatToCustomDate(date) >= formatToCustomDate(this.HREmp.DOJ) &&
              employee.EmpCode != this.exportEmp.empCode
            ) {
              this.toastr.warning(
                "PAN/Aadhar/Email & DOB is matching with the group Id " +
                  employee.GroupId +
                  ". DOJ should be after the earlier Date of exit " +
                  formatDate(date, "dd-MMM-yyyy", "en_US")
              );
              this.loader = false;
              return;
            }
          }
        }
        this.submitted = true;
        if (this.verificationForm.invalid) {
          return;
        }
        var msg = `Are you sure you want to submit?`;
        var deleteType = "Submit";
        const dialogData = new ConfirmDialogModel(" ", msg, deleteType);
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          maxWidth: "400px",
          data: dialogData,
        });
        dialogRef.afterClosed().subscribe(
          (dialogResult) => {
            if (dialogResult) {
              this.exportEmp.empId = this.EmpId;
              this.exportEmp.createdBy = this.empCode.toString();
              this.exportEmp.groupId = this.employeeDetails.GroupId;
              this.exportEmp.type = this.employeeDetails.Type;
              this.loader = true;
              this._service.SaveOnboardEmpToEmployee(this.exportEmp).subscribe(
                (data: any) => {
                  setTimeout(() => {
                    this.loader = false;
                  }, 800);
                  //this.toastr.success("Submitted successfully");
                  this.router.navigateByUrl("/employeelist");
                },
                (error) => (this.error = error)
              );
            }
          },
          (error) => {
            this.result = error;
          }
        );
        return this.result;
      }
    } else {
      if (
        this.exportEmp.empCode == null ||
        this.exportEmp.email == null ||
        this.exportEmp.peopleManagerCode == null
      ) {
        this.toastr.warning("Please fill required fields");
      } else if (this.exportEmp.empCode == null) {
        this.toastr.warning("Employee Code cannot be empty");
      } else if (this.exportEmp.email == null) {
        this.toastr.warning("Please enter email id");
      } else {
        this.toastr.warning("People Manager cannot be empty");
      }
    }
  }

  doFilter() {
    if (!isNullOrUndefined(this.peopleManagerCode)) {
      this.filteredPMList = this.filter(this.tempPMList);
    }
  }
  doSeniorFilter() {
    if (!isNullOrUndefined(this.seniorManagerCode)) {
      this.filteredSMList = this.filterSeniorManager(this.tempSMList);
    }
  }
  filterSeniorManager(values) {
    return values.filter((value) =>
      value.pmDisplayName
        .toLowerCase()
        .includes(this.seniorManagerCode.toLowerCase())
    );
  }
  filter(values) {
    return values.filter((value) =>
      value.pmDisplayName
        .toLowerCase()
        .includes(this.peopleManagerCode.toLowerCase())
    );
  }
  GetVerificationStatus() {
    this._service.GetVerificationStatus(this.EmpId).subscribe(
      (data: any) => {
        this.VerificationDetails = data;
        var count = 0;
        this.VerificationDetails.forEach((item) => {
          if (item.Status == true) {
            count += 1;
            //since tab index starts from 0 to compare with sections we add 1
            var sectionId = this.selected.value + 1;
            //if (this.selected.value + 1 == 7) {
            //  sectionId = 6;
            //}
            if (sectionId == item.SectionId) {
              this.DisableTheTabsIfChecked(sectionId);
            }
            for (var i = 0; i < this.empList.length; i++) {
              //since VerifiedBy has empCode we compare with employee list and get employee name to display
              if (this.empList[i].EmpCode == item.VerifiedBy) {
                item.EmpName = this.empList[i].FirstName;
              }
            }
          }
        });
        //count 6 indicates that all the tabs are verified
        if (count == 6) {
          this.Check = 1;
        } else {
          this.Check = 0;
        }
      },
      (error) => (this.error = error)
    );
  }

  //Disables the fields of particular tab whose tab index is passed in switch case
  DisableTheTabsIfChecked(value) {
    switch (value) {
      case 1:
        this.basicEmpDetComponent.EmpDetform.disable();
        this.basicEmpDetComponent.EmpAddform.disable();
        this.checkBoxDisable = true;
        this.checkBox = true;
        break;
      case 2: //Disables the form fields
        this.personalDetailsComponent.PersonalDetform.disable();
        this.personalDetailsComponent.emergencyContactDtlsDisable = true;
        //to disable the checkbox
        this.PersonalDetCBDisable = true;
        //to disable the save buttons
        this.PersonalDetCB = true;
        break;
      case 3:
        this.educationDetailsComponent.EducationDetailForm.disable();
        this.educationDetailsComponent.educationDtlsDisable = true;
        this.EducationDetCB = true;
        this.EducationDetCBDisable = true;
        break;
      case 4:
        this.previousEmploymentComponent.PrevEmploymentDetForm.disable();
        this.previousEmploymentComponent.prevEmpDtlsDisable = true;
        this.PrevEmpDetCB = true;
        this.PrevEmpDetCBDisable = true;
        this.previousEmploymentComponent.referenceDtlsDisable = true;
        //this.ReferenceDetCB = true;
        // this.ReferenceDetCBDisable = true;
        break;
      /* case 5: this.referenceDetailsComponent.referenceDtlsDisable = true;
        this.ReferenceDetCB = true;
        this.ReferenceDetCBDisable = true;
        break;*/
      case 5:
        this.passportvisaInformationComponent.PassportForm.disable();
        this.passportvisaInformationComponent.passportDtlsDisable = true;
        this.passportvisaInformationComponent.VisaForm.disable();
        this.passportvisaInformationComponent.visaDtlsDisable = true;
        this.PassportDetCB = true;
        this.PassportDetCBDisable = true;
        break;
      case 6:
        this.financeDetailsComponent.FinanceForm.disable();
        this.financeDetailsComponent.FinanceDtlsDisable = true;
        this.FinanceDetCB = true;
        this.FinanceDetCBDisable = true;
        break;
    }
  }

  SaveEmployeeDetails(value) {
    var linkedInUrlPattern = /^(https?:\/\/)?(www\.)?(linkedin\.com\/.*)$/;
    if (
      this.employeeDetails.LinkedInID != null &&
      this.employeeDetails.LinkedInID.trim() != "" &&
      !linkedInUrlPattern.test(this.employeeDetails.LinkedInID)
    ) {
      this.basicEmpDetComponent.isInvalidUrl = true;
    }
    this.basicEmpDetComponent.EmpAddform.markAllAsTouched();
    this.basicEmpDetComponent.EmpDetform.markAllAsTouched();
    this.datePipe = new DatePipe("en-US");
    if (this.basicEmpDetComponent.isInvalidUrl) {
      this.toastr.warning("Please enter valid LinkedIn URL");
      return;
    }
    if (!this.basicEmpDetComponent.EmpDetform.invalid) {
      if (
        !isNullOrUndefined(
          this.basicEmpDetComponent.EmpDetform.get("DOB").value
        )
      ) {
        this.employeeDetails.DOB = new Date(
          this.datePipe.transform(
            this.employeeDetails.DOB,
            this.config.dateFormat()
          )
        );
      }
      if (
        !isNullOrUndefined(
          this.basicEmpDetComponent.EmpDetform.get("CelebratedDOB").value
        )
      ) {
        this.employeeDetails.CelebratedDOB = new Date(
          this.datePipe.transform(
            this.employeeDetails.CelebratedDOB,
            this.config.dateFormat()
          )
        );
      }
      this.employeeDetails.ModifiedBy = this.empCode.toString();
    } else {
      this.toastr.warning("Please fill the required fields");
      return;
    }
    if (this.basicEmpDetComponent.EmpDetform.invalid) {
      this.toastr.warning("Please fill the required fields.");
      return;
    }
    if (this.basicEmpDetComponent.EmpAddform.invalid) {
      this.toastr.warning(
        "please fill all the details in the communication address"
      );
      return;
    }

    const pinCodeValue =
      this.basicEmpDetComponent.EmpAddform.get("PinCode")!.value;

    if (pinCodeValue && pinCodeValue.length < 5) {
      this.toastr.warning("Pincode must be at least 5 digits");
      return;
    }

    if (this.checkBox == true) {
      this.SaveVerificationDetails(this.selected.value + 1);
      this.employeeDetails.onboardVrifications = this.Verify;
    } else {
      this.employeeDetails.onboardVrifications = null;
    }
    this.basicEmpDetComponent.EmpDetform.controls.AadharFile.reset();
    this.basicEmpDetComponent.EmpDetform.controls.PanFile.reset();
    this.basicEmpDetComponent.EmpDetform.controls.ResumeFile.reset();

    this.loader = true;
    //var employee = this.employeelist != null ? this.employeelist.find(emp => (emp.PAN != null && this.employeeDetails.PAN != null && emp.PAN == this.employeeDetails.PAN) || (emp.Aadhar != null && this.employeeDetails.Aadhar && emp.Aadhar == this.employeeDetails.Aadhar) || (emp.Email == this.employeeDetails.Email && emp.DOB == this.employeeDetails.DOB) && this.employeeDetails.GroupId != emp.GroupId) : null;
    //if (employee != null && employee != undefined) {
    //  if (employee.IsMigratedOnH1 ? employee.US_DOE == null : employee.DateOfExit == null) {
    //    this.toastr.warning("Same Details exists for employee " + employee.EmpCode);
    //    this.loader = false;
    //    return;
    //  }
    //  else if (employee.IsMigratedOnH1 ? employee.US_DOE != null : employee.DateOfExit != null) {
    //    this.toastr.warning("Same Details exists for group Id " + employee.GroupId);
    //    this.loader = false;
    //    return;
    //  }
    //}
    this._service.saveEmpDetails(this.employeeDetails).subscribe(
      (data: any) => {
        this.basicEmpDetComponent.getEmployeebySlugStatus();
        this.GetVerificationStatus();
        this.toastr.success("Saved Successfully");
        setTimeout(() => {
          this.loader = false;
        }, 800);
        if (value) {
          this.changeTab();
        }
      },
      (error) => this.toastr.warning(error)
    );
  }

  async SavePersonalEmpDetails(value) {
    this.datePipe = new DatePipe("en-US");
    this.personalDetails.EmpId = this.EmpId;
    this.personalDetails.ModifiedBy = this.empCode.toString();
    if (
      this.personalDetails.NoOfDependents != null &&
      this.personalDetails.NoOfDependents.toString() == ""
    ) {
      this.Children.clear();
    }
    this.personalDetailsComponent.PersonalDetform.markAllAsTouched();
    this.personalDetailsComponent.detectChanges();
    const controls = this.personalDetailsComponent.PersonalDetform.controls;

    for (const controlName in controls) {
      if (controls[controlName].invalid) {
      }
    }
    if (this.personalDetailsComponent.PersonalDetform.invalid) {
      this.toastr.warning("Please fill the required fields");
      return;
    }
    if (this.personalDetails.emergencyContactDtls.length < 1) {
      this.toastr.warning("Please fill the emergency contact details");
      return;
    }
    for (var i = 0; i < this.personalDetails.emergencyContactDtls.length; i++) {
      let element = this.personalDetails.emergencyContactDtls[i];
      if (
        element.ContactPhoneNumber &&
        element.ContactPhoneNumber.length !== 10
      ) {
        this.toastr.warning("Please enter a valid 10-digit Phone Number");
        this.loader = false;
        return;
      }
    }
    for (var i = 0; i < this.personalDetails.emergencyContactDtls.length; i++) {
      let element = this.personalDetails.emergencyContactDtls[i];
      if (
        (isNullOrUndefined(element.ContactPersonName) ||
          element.ContactPersonName == "") &&
        (isNullOrUndefined(element.ContactPhoneNumber) ||
          element.ContactPhoneNumber == "") &&
        isNullOrUndefined(element.RelationId)
      ) {
        this.toastr.warning("Please fill the emergency contact details");
        return;
      }

      if (
        this.personalDetails.emergencyContactDtls[i].ContactPersonName !=
          null &&
        this.personalDetails.emergencyContactDtls[i].ContactPersonName != ""
      ) {
        if (
          this.personalDetails.emergencyContactDtls[i].ContactPhoneNumber ==
            null ||
          this.personalDetails.emergencyContactDtls[i].ContactPhoneNumber ==
            "" ||
          isNullOrUndefined(
            this.personalDetails.emergencyContactDtls[i].RelationId
          )
        ) {
          this.toastr.warning(
            "Please fill the remaining fields in emergency contact details"
          );
          return;
        }
      } else {
        if (
          this.personalDetails.emergencyContactDtls[i].ContactPhoneNumber !=
            null ||
          !isNullOrUndefined(
            this.personalDetails.emergencyContactDtls[i].RelationId
          )
        ) {
          this.toastr.warning(
            "Please enter the name in emergency contact details"
          );
          return;
        }
      }
      this.personalDetails.emergencyContactDtls[i].EmpId = this.EmpId;
      this.personalDetails.emergencyContactDtls[i].ModifiedBy =
        this.empCode.toString();
    }

    //Assigned father,mother,spouse and children details are moved to array of FamilyDetails
    this.personalDetails.FamilyDetails = [];
    this.personalDetails.Father.RelationId = 1; // RelationId 1 indicates father
    this.personalDetails.FamilyDetails[0] = this.personalDetails.Father;
    this.personalDetails.Mother.RelationId = 2; // RelationId 2 indicates mother
    this.personalDetails.FamilyDetails[1] = this.personalDetails.Mother;
    if (this.personalDetails.MaritalStatus == 1) {
      //MaritalStatus 1 indicates Married
      //If wedding date has value then changes the date format
      if (!isNullOrUndefined(this.personalDetails.WeddingDate))
        this.personalDetails.WeddingDate = new Date(
          this.datePipe.transform(
            this.personalDetails.WeddingDate,
            this.config.dateFormat()
          )
        );
      this.personalDetails.Spouse.RelationId = 3; // RelationId 3 indicates spouse
      this.personalDetails.FamilyDetails[2] = this.personalDetails.Spouse;
    }
    if (this.personalDetails.MaritalStatus) {
      if (this.personalDetails.MaritalStatus == 1) {
        var j = 3;
      } else {
        var j = 2;
      }
      for (var i = 0; i < this.Children.value.length; i++) {
        this.personalDetails.FamilyDetails[j] = this.Children.value[i];
        j += 1;
      }
    }
    //for (var i = 0; i < this.Children.value.length; i++) {
    //  var child = this.Children.value[i];
    //  if (child.Name == "" || child.RelationId == "" || child.DOB == "") {
    //    this.toastr.warning("Please fill the required fields");
    //    return;
    //  }
    //}
    if (this.Children.value.length > 0) {
      for (var i = 0; i < this.Children.value.length; i++) {
        var child = this.Children.value[i];
        if (child.Name == "" || child.RelationId == "" || child.DOB == "") {
          this.toastr.warning("Please fill the required fields");
          return;
        }
      }
    }
    if (this.personalDetails.NoOfDependents == 0) {
      this.Children.reset();
    }
    for (var i = 0; i < this.personalDetails.FamilyDetails.length; i++) {
      this.personalDetails.FamilyDetails[i].EmpID = this.EmpId;
      this.personalDetails.FamilyDetails[i].ModifiedBy =
        this.empCode.toString();
      if (!isNullOrUndefined(this.personalDetails.FamilyDetails[i].DOB))
        this.personalDetails.FamilyDetails[i].DOB = new Date(
          this.datePipe.transform(
            this.personalDetails.FamilyDetails[i].DOB,
            this.config.dateFormat()
          )
        );
    }
    if (this.PersonalDetCB == true) {
      this.SaveVerificationDetails(this.selected.value + 1);
      this.personalDetails.onboardVrifications = this.Verify;
    } else {
      this.personalDetails.onboardVrifications = null;
    }
    this.loader = true;

    this._service.SavePersonalEmpDetails(this.personalDetails).subscribe(
      (data: any) => {
        this.toastr.success("Saved Successfully");
        setTimeout(() => {
          this.loader = false;
        }, 800);
        this.GetVerificationStatus();
        if (value) {
          this.changeTab();
        }
      },
      (error) => this.toastr.warning(error)
    );
  }

  async SavePassportVisaDetails(value) {
    this.datePipe = new DatePipe("en-US");
    if (this.passportArray.value.length != 0) {
      for (var j = 0; j < this.passportArray.value.length; j++) {
        var element = this.passportArray.value[j];
        if (
          (element.DocNumber == null || element.DocNumber == "") &&
          element.IssueDate == null &&
          element.ExpiryDate == null &&
          element.Country == "" &&
          element.File == ""
        ) {
          this.passportArray.value.splice(j, 1);
          j--;
        }
      }
      if (this.passportArray.value.length != 0) {
        const passportDetails = this.passportArray;
        await Promise.all(
          passportDetails.value.map(async (details) => {
            if (
              details.File != null &&
              details.File.files &&
              details.File.files.length > 0
            ) {
              const chequeFile = details.File.files[0];
              details.File = await this.file_Svc.convertFileToFileToUpload(
                chequeFile
              );
              this.passportArray = passportDetails;
            }
          })
        );
      }
      for (var k = 0; k < this.passportArray.value.length; k++) {
        var count = 0;
        for (var l = 0; l < this.passportArray.value.length; l++) {
          var passport1 = this.passportArray.value[k];
          var passport2 = this.passportArray.value[l];
          if (passport1.ExpiryDate != null && passport2.ExpiryDate != null) {
            passport1.ExpiryDate = formatDate(
              passport1.ExpiryDate,
              "dd-MMM-yyyy",
              "en_US"
            );
            passport2.ExpiryDate = formatDate(
              passport2.ExpiryDate,
              "dd-MMM-yyyy",
              "en_US"
            );
          }
          if (
            !isNullOrUndefined(passport1.DocNumber) &&
            passport1.DocNumber != "" &&
            !isNullOrUndefined(passport2.DocNumber) &&
            passport2.DocNumber != "" &&
            passport1.ExpiryDate != null &&
            passport2.ExpiryDate != null &&
            passport1.DocNumber == passport2.DocNumber &&
            passport1.ExpiryDate == passport2.ExpiryDate
          ) {
            count++;
          }
        }
      }
      if (count > 1) {
        this.toastr.warning(
          "Passport number and Expiry date must be unique in passport information"
        );
        return;
      }
      for (var i = 0; i < this.passportArray.value.length; i++) {
        this.passportArray.value[i].EmpId = this.EmpId;
        this.passportArray.value[i].ModifiedBy = this.empCode.toString();
        if (
          !isNullOrUndefined(this.passportArray.value[i].DocNumber) &&
          this.passportArray.value[i].DocNumber != "" &&
          this.passportArray.value[i].DocNumber.length < 4
        ) {
          this.toastr.warning("Enter valid passport number");
          return;
        }
        if (this.passportArray.value[i].IssueDate != null)
          this.passportArray.value[i].IssueDate = new Date(
            this.datePipe.transform(
              this.passportArray.value[i].IssueDate,
              this.config.dateFormat()
            )
          );
        if (this.passportArray.value[i].ExpiryDate != null)
          this.passportArray.value[i].ExpiryDate = new Date(
            this.datePipe.transform(
              this.passportArray.value[i].ExpiryDate,
              this.config.dateFormat()
            )
          );
        this.passportArray.value[i].EmpId = this.EmpId;
        this.passportArray.value[i].ModifiedBy = this.empCode.toString();
        if (
          !isNullOrUndefined(this.passportArray.value[i].DocNumber) &&
          !isNullOrUndefined(this.passportArray.value[i].IssueDate) &&
          !isNullOrUndefined(this.passportArray.value[i].ExpiryDate)
        ) {
          if (
            this.passportArray.value[i].IssueDate >=
            this.passportArray.value[i].ExpiryDate
          ) {
            this.toastr.warning(
              "Passport Issue Date should not be greater than or equal to Expiry Date"
            );
            return;
          }
        }
        if (
          !isNullOrUndefined(this.passportArray.value[i].File) &&
          this.passportArray.value[i].File != ""
        ) {
          if (
            isNullOrUndefined(this.passportArray.value[i].DocNumber) ||
            isNullOrUndefined(this.passportArray.value[i].IssueDate) ||
            isNullOrUndefined(this.passportArray.value[i].ExpiryDate) ||
            isNullOrUndefined(this.passportArray.value[i].Country) ||
            this.passportArray.value[i].Country == ""
          ) {
            this.toastr.warning(
              "Please fill the details to save the passport file"
            );
            return;
          }
        }
        if (
          !isNullOrUndefined(this.passportArray.value[i].DocNumber) &&
          this.passportArray.value[i].DocNumber != ""
        ) {
          if (
            isNullOrUndefined(this.passportArray.value[i].IssueDate) ||
            isNullOrUndefined(this.passportArray.value[i].ExpiryDate) ||
            isNullOrUndefined(this.passportArray.value[i].Country) ||
            this.passportArray.value[i].Country == ""
          ) {
            this.toastr.warning(
              "Please fill the remaining details for your passport information"
            );
            return;
          }
        } else if (!isNullOrUndefined(this.passportArray.value[i].IssueDate)) {
          if (
            isNullOrUndefined(this.passportArray.value[i].DocNumber) ||
            this.passportArray.value[i].DocNumber == "" ||
            isNullOrUndefined(this.passportArray.value[i].ExpiryDate) ||
            isNullOrUndefined(this.passportArray.value[i].Country) ||
            this.passportArray.value[i].Country == ""
          ) {
            this.toastr.warning(
              "Please fill the remaining details for your passport information"
            );
            return;
          }
        } else if (!isNullOrUndefined(this.passportArray.value[i].ExpiryDate)) {
          if (
            isNullOrUndefined(this.passportArray.value[i].DocNumber) ||
            this.passportArray.value[i].DocNumber == "" ||
            isNullOrUndefined(this.passportArray.value[i].IssueDate) ||
            isNullOrUndefined(this.passportArray.value[i].Country) ||
            this.passportArray.value[i].Country == ""
          ) {
            this.toastr.warning(
              "Please fill the remaining details for your passport information"
            );
            return;
          }
        } else if (
          !isNullOrUndefined(this.passportArray.value[i].Country) &&
          this.passportArray.value[i].Country != ""
        ) {
          if (
            isNullOrUndefined(this.passportArray.value[i].IssueDate) ||
            isNullOrUndefined(this.passportArray.value[i].ExpiryDate) ||
            isNullOrUndefined(this.passportArray.value[i].DocNumber) ||
            this.passportArray.value[i].DocNumber == ""
          ) {
            this.toastr.warning(
              "Please fill the remaining details for your passport information"
            );
            return;
          }
        }
        if (
          this.passportArray.value[i].ID <= 0 &&
          (isNullOrUndefined(this.passportArray.value[i].File) ||
            this.passportArray.value[i].File == "")
        ) {
          if (
            (!isNullOrUndefined(this.passportArray.value[i].Country) &&
              this.passportArray.value[i].Country != "") ||
            !isNullOrUndefined(this.passportArray.value[i].ExpiryDate) ||
            !isNullOrUndefined(this.passportArray.value[i].IssueDate) ||
            (!isNullOrUndefined(this.passportArray.value[i].DocNumber) &&
              this.passportArray.value[i].DocNumber != "")
          ) {
            this.toastr.warning(
              "Please select document to save the remaining details for your passport"
            );
            return;
          }
        }
      }
    }
    if (this.visaArray.value.length != 0) {
      const visaDetails = this.visaArray;
      await Promise.all(
        visaDetails.value.map(async (details) => {
          if (
            details.File != null &&
            details.File.files &&
            details.File.files.length > 0
          ) {
            const chequeFile = details.File.files[0];
            details.File = await this.file_Svc.convertFileToFileToUpload(
              chequeFile
            );
            this.visaArray = visaDetails;
          }
        })
      );
      for (var i = 0; i < this.visaArray.value.length; i++) {
        this.visaArray.value[i].Country =
          this.visaArray.value[i].Country == "Other"
            ? this.visaArray.value[i].CountryName
            : this.visaArray.value[i].Country;
        this.visaArray.value[i].EmpCode = this.empCode;
        this.visaArray.value[i].Validity = new Date(
          this.datePipe.transform(
            this.visaArray.value[i].Validity,
            this.config.dateFormat()
          )
        );
        this.visaArray.value[i].EmpId = this.EmpId;
        this.visaArray.value[i].ModifiedBy = this.empCode.toString();
        if (!isNullOrUndefined(this.visaArray.value[i].ExpiryDate))
          this.visaArray.value[i].ExpiryDate = new Date(
            this.datePipe.transform(
              this.visaArray.value[i].ExpiryDate,
              this.config.dateFormat()
            )
          );
        if (
          !isNullOrUndefined(this.visaArray.value[i].File) &&
          this.visaArray.value[i].File != ""
        ) {
          if (
            this.visaArray.value[i].Country === "" ||
            (this.visaArray.value[i].Country === "Other" &&
              this.visaArray.value[i].CountryName === "") ||
            this.visaArray.value[i].DocType === "" ||
            isNullOrUndefined(this.visaArray.value[i].ExpiryDate)
          ) {
            this.toastr.warning(
              "Please fill the details to save the visa file"
            );
            return;
          }
        } else if (
          this.visaArray.value[i].Country != "" ||
          (this.visaArray.value[i].Country === "Other" &&
            this.visaArray.value[i].CountryName === "")
        ) {
          if (
            this.visaArray.value[i].DocType === "" ||
            isNullOrUndefined(this.visaArray.value[i].ExpiryDate)
          ) {
            this.toastr.warning(
              "Please fill the remaining details for your visa information"
            );
            return;
          }
        } else if (this.visaArray.value[i].DocType != "") {
          if (
            this.visaArray.value[i].Country === "" ||
            isNullOrUndefined(this.visaArray.value[i].ExpiryDate)
          ) {
            this.toastr.warning(
              "Please fill the remaining details for your visa information"
            );
            return;
          }
        } else if (!isNullOrUndefined(this.visaArray.value[i].ExpiryDate)) {
          if (
            this.visaArray.value[i].DocType === "" ||
            this.visaArray.value[i].Country === ""
          ) {
            this.toastr.warning(
              "Please fill the remaining details for your visa information"
            );
            return;
          }
        }
        if (
          this.visaArray.value[i].ExpiryDate &&
          this.visaArray.value[i].DocType != "" &&
          this.visaArray.value[i].Country != "" &&
          (isNullOrUndefined(this.visaArray.value[i].File) ||
            this.visaArray.value[i].File === "")
        ) {
          if (isNullOrUndefined(this.visaArray.value[i].DocumentPath)) {
            this.toastr.warning("Please attach the visa file");
            return;
          }
        }
      }
    }
    this.passportVisaDetails.onboardPassport = this.passportArray.value;
    this.passportVisaDetails.onboardVisas = this.visaArray.value;
    if (this.PassportDetCB == true) {
      this.SaveVerificationDetails(this.selected.value + 1);
      this.passportVisaDetails.onboardVrifications = this.Verify;
    } else {
      this.passportVisaDetails.onboardVrifications = null;
    }

    this.loader = true;

    this._service.SavePassportVisaDetails(this.passportVisaDetails).subscribe(
      (data: any) => {
        this.passportvisaInformationComponent.GetPassportVisaInfo();
        this.GetVerificationStatus();
        this.toastr.success("Saved Successfully");
        setTimeout(() => {
          this.loader = false;
        }, 800);
        //if value is true then it is moved to next tab
        if (value) {
          this.changeTab();
        }
      },
      (error) => this.toastr.warning(error)
    );
  }

  async SaveFinanceDetails(value) {
    this.financeDetailsComponent.FinanceForm.markAllAsTouched();
    window.scrollTo(0, 0);
    if (
      this.FinanceDetails.NoOfAccounts == null ||
      this.FinanceDetails.NoOfAccounts == 0
    ) {
      this.toastr.warning("No. of bank accounts should be atleast one");
      this.loader = false;
      return;
    }
    this.FinanceDetails.empFinanceDetails =
      this.financeDetailsComponent.GetFinanceDetails();
    const financeDetails = this.financeDetailsComponent.GetFinanceDetails();
    await Promise.all(
      financeDetails.map(async (details) => {
        if (
          details.CancelledChequeFile &&
          details.CancelledChequeFile.files &&
          details.CancelledChequeFile.files.length > 0
        ) {
          const chequeFile = details.CancelledChequeFile.files[0];
          details.CancelledChequeFile =
            await this.file_Svc.convertFileToFileToUpload(chequeFile);
          this.FinanceDetails.empFinanceDetails = financeDetails;
        }
      })
    );
    this.FinanceDetails.ModifiedBy = this.empCode.toString();
    for (var i = 0; i < this.FinanceDetails.empFinanceDetails.length; i++) {
      let element = this.FinanceDetails.empFinanceDetails[i];
      element.EmpCode = this.EmpId;
      element.CreatedBy =
        element.Id > 0 ? element.CreatedBy : this.empCode.toString();
      element.ModifiedBy = this.empCode.toString();
      if (
        isNullOrUndefined(element.BankAccount) ||
        element.BankAccount == "" ||
        isNullOrUndefined(element.IFSCCode) ||
        element.IFSCCode == "" ||
        isNullOrUndefined(element.BankAccountName) ||
        element.BankAccountName == "" ||
        isNullOrUndefined(element.BankName) ||
        element.BankName == "" ||
        isNullOrUndefined(element.Branch) ||
        element.Branch == "" ||
        ((isNullOrUndefined(element.CancelledChequeFile) ||
          element.CancelledChequeFile.fileName == "") &&
          isNullOrUndefined(element.CancelledChequeFilePath))
      ) {
        this.toastr.warning("Please fill all the details in Bank Accounts");
        this.loader = false;
        return;
      } else if (
        !isNullOrUndefined(element.BankAccount) &&
        element.BankAccount != ""
      ) {
        if (
          isNullOrUndefined(element.IFSCCode) ||
          element.IFSCCode == "" ||
          isNullOrUndefined(element.BankAccountName) ||
          element.BankAccountName == "" ||
          isNullOrUndefined(element.BankName) ||
          element.BankName == "" ||
          isNullOrUndefined(element.Branch) ||
          element.Branch == "" ||
          ((isNullOrUndefined(element.CancelledChequeFile) ||
            element.CancelledChequeFile.fileName == "") &&
            isNullOrUndefined(element.CancelledChequeFilePath))
        ) {
          this.toastr.warning("Please fill all the details in Bank Accounts");
          this.loader = false;
          return;
        }
      } else if (
        !isNullOrUndefined(element.IFSCCode) &&
        element.IFSCCode != ""
      ) {
        if (
          isNullOrUndefined(element.BankAccount) ||
          element.BankAccount == "" ||
          isNullOrUndefined(element.BankAccountName) ||
          element.BankAccountName == "" ||
          isNullOrUndefined(element.BankName) ||
          element.BankName == "" ||
          isNullOrUndefined(element.Branch) ||
          element.Branch == "" ||
          ((isNullOrUndefined(element.CancelledChequeFile) ||
            element.CancelledChequeFile.fileName == "") &&
            isNullOrUndefined(element.CancelledChequeFilePath))
        ) {
          this.toastr.warning("Please fill all the details in Bank Accounts");
          this.loader = false;
          return;
        }
      } else if (
        !isNullOrUndefined(element.BankAccountName) &&
        element.BankAccountName != ""
      ) {
        if (
          isNullOrUndefined(element.BankAccount) ||
          element.BankAccount == "" ||
          isNullOrUndefined(element.IFSCCode) ||
          element.IFSCCode == "" ||
          isNullOrUndefined(element.BankName) ||
          element.BankName == "" ||
          isNullOrUndefined(element.Branch) ||
          element.Branch == "" ||
          ((isNullOrUndefined(element.CancelledChequeFile) ||
            element.CancelledChequeFile.fileName == "") &&
            isNullOrUndefined(element.CancelledChequeFilePath))
        ) {
          this.toastr.warning("Please fill all the details in Bank Accounts");
          this.loader = false;
          return;
        }
      } else if (
        !isNullOrUndefined(element.BankName) &&
        element.BankName != ""
      ) {
        if (
          isNullOrUndefined(element.BankAccount) ||
          element.BankAccount == "" ||
          isNullOrUndefined(element.IFSCCode) ||
          element.IFSCCode == "" ||
          isNullOrUndefined(element.BankAccountName) ||
          element.BankAccountName == "" ||
          isNullOrUndefined(element.Branch) ||
          element.Branch == "" ||
          ((isNullOrUndefined(element.CancelledChequeFile) ||
            element.CancelledChequeFile.fileName == "") &&
            isNullOrUndefined(element.CancelledChequeFilePath))
        ) {
          this.toastr.warning("Please fill all the details in Bank Accounts");
          this.loader = false;
          return;
        }
      } else if (!isNullOrUndefined(element.Branch) && element.Branch != "") {
        if (
          isNullOrUndefined(element.BankAccount) ||
          element.BankAccount == "" ||
          isNullOrUndefined(element.IFSCCode) ||
          element.IFSCCode == "" ||
          isNullOrUndefined(element.BankAccountName) ||
          element.BankAccountName == "" ||
          isNullOrUndefined(element.BankName) ||
          element.BankName == "" ||
          ((isNullOrUndefined(element.CancelledChequeFile) ||
            element.CancelledChequeFile.fileName == "") &&
            isNullOrUndefined(element.CancelledChequeFilePath))
        ) {
          this.toastr.warning("Please fill all the details in Bank Accounts");
          this.loader = false;
          return;
        }
      } else if (
        (!isNullOrUndefined(element.CancelledChequeFile) &&
          element.CancelledChequeFile.fileName != "") ||
        !isNullOrUndefined(element.CancelledChequeFilePath)
      ) {
        if (
          isNullOrUndefined(element.BankAccount) ||
          element.BankAccount == "" ||
          isNullOrUndefined(element.IFSCCode) ||
          element.IFSCCode == "" ||
          isNullOrUndefined(element.BankAccountName) ||
          element.BankAccountName == "" ||
          isNullOrUndefined(element.BankName) ||
          element.BankName == "" ||
          (isNullOrUndefined(element.Branch) && element.Branch == "")
        ) {
          this.toastr.warning("Please fill all the details in Bank Accounts");
          this.loader = false;
          return;
        }
      }
    }
    for (var k = 0; k < this.FinanceDetails.empFinanceDetails.length; k++) {
      var count = 0;
      for (var l = 0; l < this.FinanceDetails.empFinanceDetails.length; l++) {
        var finance1 = this.FinanceDetails.empFinanceDetails[k];
        var finance2 = this.FinanceDetails.empFinanceDetails[l];
        if (
          !isNullOrUndefined(finance1.BankAccount) &&
          finance1.BankAccount != "" &&
          !isNullOrUndefined(finance2.BankAccount) &&
          finance2.BankAccount != "" &&
          !isNullOrUndefined(finance1.IFSCCode) &&
          finance1.IFSCCode != "" &&
          !isNullOrUndefined(finance2.IFSCCode) &&
          finance2.IFSCCode != "" &&
          finance1.BankAccount == finance2.BankAccount &&
          finance1.IFSCCode == finance2.IFSCCode
        ) {
          count++;
        }
      }
    }
    if (count > 1) {
      this.toastr.warning(
        "Bank Account# and IFSC Code must be unique in finance details"
      );
      this.loader = false;
      return;
    }
    if (this.financeDetailsComponent.FinanceForm.invalid) {
      this.toastr.warning("Please fill the require fields");
      this.loader = false;
      return;
    }
    let anyCheckboxChecked =
      this.FinanceDetails.empFinanceDetails.length > 0
        ? this.FinanceDetails.empFinanceDetails.some(
            (item) => item.BankAccount != "" && item.Primary
          )
        : false;
    if (!anyCheckboxChecked) {
      this.toastr.warning("Please select the primary bank account");
      return;
    }
    if (this.FinanceDetCB == true) {
      this.SaveVerificationDetails(this.selected.value + 1);
      this.FinanceDetails.onboardVrifications = this.Verify;
    } else {
      this.FinanceDetails.onboardVrifications = null;
    }
    this.FinanceDetails.ModifiedBy = this.empCode.toString();
    this.loader = true;
    this._service.SaveFinanceDetails(this.FinanceDetails).subscribe(
      (data: any) => {
        this.financeDetailsComponent.GetOnboardEmpolyeeFinanceDetails();
        this.GetVerificationStatus();
        this.toastr.success("Saved Successfully");
        setTimeout(() => {
          this.loader = false;
        }, 800);
        if (value) {
          this.changeTab();
        }
      },
      (error) => this.toastr.warning(error)
    );
  }

  //Create verify object with tab id passed to it
  SaveVerificationDetails(tabId) {
    this.Verify = new OnboardVrifications();
    this.Verify.SectionId = tabId;
    this.Verify.VerifiedBy = this.empCode;
    this.Verify.EmpId = this.EmpId;
    this.Verify.Status = true;
  }

  Reset() {
    if (this.checkBox == true) {
      this.checkBox = false;
    } else if (this.PersonalDetCB == true) {
      this.PersonalDetCB = false;
    } else if (this.EducationDetCB == true) {
      this.EducationDetCB = false;
    } else if (this.PrevEmpDetCB == true) {
      this.PrevEmpDetCB = false;
    } else if (this.PassportDetCB == true) {
      this.PassportDetCB = false;
    } else if (this.FinanceDetCB == true) {
      this.FinanceDetCB = false;
    }
  }

  private requireMatchPM(control: FormControl): ValidationErrors | null {
    const selection: any = control.value;
    let match = null;
    if (!isNullOrUndefined(selection) && selection != "") {
      if (!isNullOrUndefined(this.filteredPMList)) {
        for (var i = 0; i < this.filteredPMList.length; i++) {
          if (this.filteredPMList[i].pmDisplayName == selection) {
            match = null;
            break;
          } else {
            match = true;
          }
        }
        if (match == true) {
          return { requireMatchPM: match };
        }
      }
    } else {
      return null;
    }
  }

  private requireMatchSM(control: FormControl): ValidationErrors | null {
    const selection: any = control.value;
    let match = null;
    if (!isNullOrUndefined(selection) && selection != "") {
      if (!isNullOrUndefined(this.filteredSMList)) {
        for (var i = 0; i < this.filteredSMList.length; i++) {
          if (this.filteredSMList[i].smDisplayName == selection) {
            match = null;
            break;
          } else {
            match = true;
          }
        }
        if (match == true) {
          return { requireMatchSM: match };
        }
      }
    } else {
      return null;
    }
  }

  Cancel() {
    this.router.navigateByUrl("/employeelist");
  }
  //Custom Validation for email
  emailDomain(control: AbstractControl): { [key: string]: any } | null {
    if (control.value != null) {
      const emailId: string = control.value;
      const domain = emailId.substring(emailId.lastIndexOf("@") + 1);
      if (emailId === "" || domain.toLowerCase() === "winwire.com") {
        return null;
      } else {
        return { emailDomain: true };
      }
    }
  }
  //SaveVerificationDetailsWithEmptyData(tabId) {
  //  this.Verify.SectionId = tabId;
  //  this.Verify.VrifyedBy = this.empCode;
  //  this.Verify.EmpId = this.EmpId;
  //  this.Verify.Status = true;
  //  this._service.SaveVrificationStatus(this.Verify).subscribe((data: any) => {
  //    this.toastr.success("Saved Successfully");
  //  }, error => this.toastr.warning(error));
  //}
}

export class pmObj {
  pmDisplayName: string;
  pmEmpCode: number;
  pmDesignation: string;
  smDisplayName: string;
}

function formatToCustomDate(date: any): Date {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}
